import { render, staticRenderFns } from "./HiddenEditor.vue?vue&type=template&id=2cf4009d&scoped=true"
import script from "./HiddenEditor.vue?vue&type=script&lang=js"
export * from "./HiddenEditor.vue?vue&type=script&lang=js"
import style0 from "./HiddenEditor.vue?vue&type=style&index=0&id=2cf4009d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4009d",
  null
  
)

export default component.exports